/** 日管控触发事件类型（文案前端固定，次数取 today_event_stat） */
export const DAILY_EVENT_CHART_COLORS = [
  '#00d4ff',
  '#ffaa00',
  '#00ff88',
  '#ff3366',
  '#9966ff',
  '#ff6699',
  '#66ccff',
  '#ffcc00',
  '#00ffcc',
  '#ff9933',
  '#cc66ff',
  '#33ff99',
  '#ff5588',
  '#88aaff',
  '#ffdd44',
  '#44ddff',
  '#aa66ff',
  '#ff8844',
  '#66ffaa',
  '#dd66ff',
  '#aaddff'
]

/** 接口 today_event_stat.event_code → 前端 countKey */
const EVENT_CODE_MAP = {
  8: 'tikun_num',
  2: 'dian_num',
  16: 'changshi_num',
  128: 'zhedang_num',
  64: 'chao_num',
  2048: 'yichang_num',
  4096: 'doudong_num',
  8192: 'caosu_num',
  32768: 'chongding_num',
  65536: 'dongdi_num',
  131072: 'zouti_num',
  262144: 'fanfu_num',
  524288: 'wuren_num',
  1048576: 'pohuai_num',
  2097152: 'zuiti_num',
  4194304: 'jiting_num',
  16777216: 'feipingceng_num',
  33554432: 'meiqi_num',
  67108864: 'duandian_num',
  134217728: 'dianchi_num',
  1: 'yijian_num'
}

export const DAILY_EVENT_TYPES = [
  { key: 'tikun', label: '滞留轿厢/梯困事件', shortLabel: '滞留轿厢', countKey: 'tikun_num', eventCode: 8, matchKeywords: ['梯困', '滞留轿厢'] },
  { key: 'dian', label: '电瓶车触发事件', shortLabel: '电瓶车', countKey: 'dian_num', eventCode: 2, matchKeywords: ['电瓶车'] },
  { key: 'changshi', label: '长时间开门事件', shortLabel: '长时间开门', countKey: 'changshi_num', eventCode: 16, matchKeywords: ['长时间开门', '长时间开'] },
  { key: 'zhedang', label: '镜头遮挡事件', shortLabel: '镜头遮挡', countKey: 'zhedang_num', eventCode: 128, matchKeywords: ['镜头遮挡', '遮挡'] },
  { key: 'chao', label: '人员超载事件', shortLabel: '人员超载', countKey: 'chao_num', eventCode: 64, matchKeywords: ['人员超载', '超载'] },
  { key: 'yichang', label: '异常声音（呼救）事件', shortLabel: '异常声音', countKey: 'yichang_num', eventCode: 2048, matchKeywords: ['异常声音', '呼救'] },
  { key: 'doudong', label: '电梯抖动（搬运/打闹）事件', shortLabel: '电梯抖动', countKey: 'doudong_num', eventCode: 4096, matchKeywords: ['电梯抖动', '抖动'] },
  { key: 'caosu', label: '超速事件', shortLabel: '超速', countKey: 'caosu_num', eventCode: 8192, matchKeywords: ['超速'] },
  { key: 'chongding', label: '冲顶事件', shortLabel: '冲顶', countKey: 'chongding_num', eventCode: 32768, matchKeywords: ['冲顶'] },
  { key: 'dongdi', label: '蹲底事件', shortLabel: '蹲底', countKey: 'dongdi_num', eventCode: 65536, matchKeywords: ['蹲底'] },
  { key: 'zouti', label: '开门走梯事件', shortLabel: '开门走梯', countKey: 'zouti_num', eventCode: 131072, matchKeywords: ['开门走梯', '走梯'] },
  { key: 'fanfu', label: '反复开关门事件', shortLabel: '反复开关门', countKey: 'fanfu_num', eventCode: 262144, matchKeywords: ['反复开关门', '反复开关'] },
  { key: 'wuren', label: '无人高频运行事件', shortLabel: '无人高频', countKey: 'wuren_num', eventCode: 524288, matchKeywords: ['无人高频', '高频运行'] },
  { key: 'pohuai', label: '破坏电梯事件', shortLabel: '破坏电梯', countKey: 'pohuai_num', eventCode: 1048576, matchKeywords: ['破坏电梯', '破坏'] },
  { key: 'zuiti', label: '坠梯事件', shortLabel: '坠梯', countKey: 'zuiti_num', eventCode: 2097152, matchKeywords: ['坠梯'] },
  { key: 'jiting', label: '急停事件', shortLabel: '急停', countKey: 'jiting_num', eventCode: 4194304, matchKeywords: ['急停'] },
  { key: 'feipingceng', label: '非平层停梯事件', shortLabel: '非平层停梯', countKey: 'feipingceng_num', eventCode: 16777216, matchKeywords: ['非平层', '平层停梯'] },
  { key: 'meiqi', label: '煤气罐事件', shortLabel: '煤气罐', countKey: 'meiqi_num', eventCode: 33554432, matchKeywords: ['煤气罐'] },
  { key: 'duandian', label: '断电告警事件', shortLabel: '断电告警', countKey: 'duandian_num', eventCode: 67108864, matchKeywords: ['断电告警', '断电'] },
  { key: 'dianchi', label: '电池触发事件', shortLabel: '电池触发', countKey: 'dianchi_num', eventCode: 134217728, matchKeywords: ['电池触发', '电池'] },
  { key: 'yijian', label: '一键报警事件', shortLabel: '一键报警', countKey: 'yijian_num', eventCode: 1, matchKeywords: ['一键报警', '一键呼救', '一键报警困人'] }
]

const TYPE_BY_COUNT_KEY = Object.fromEntries(
  DAILY_EVENT_TYPES.map((item) => [item.countKey, item])
)

function findTypeByEventCode(eventCode, eventName) {
  const code = Number(eventCode)
  if (EVENT_CODE_MAP[code]) {
    return TYPE_BY_COUNT_KEY[EVENT_CODE_MAP[code]]
  }
  if (!eventName) return null
  const text = String(eventName).trim()
  return DAILY_EVENT_TYPES.find((type) =>
    type.matchKeywords.some((keyword) => text.includes(keyword)) ||
    type.label.includes(text) ||
    text.includes(type.shortLabel)
  )
}

function getEventTypeFromRecord(evt) {
  const evtCode = evt.event_code ?? evt.event
  const evtName = (evt.event_name || '').trim()
  const evtStr = (evt.event_str || evt.event_text || '').trim()

  const eventNumberMatch = evtStr.match(/^Event\s+(\d+)$/i)
  if (eventNumberMatch) {
    const fromEventNumber = findTypeByEventCode(eventNumberMatch[1], evtName)
    if (fromEventNumber) return fromEventNumber
  }

  return (
    findTypeByEventCode(evtCode, evtName) ||
    findTypeByEventCode(evtCode, evtStr) ||
    findTypeByEventCode(null, evtName) ||
    findTypeByEventCode(null, evtStr)
  )
}

function pickBetterEventList(candidates, expectedCount = 0) {
  const lists = candidates.filter((list) => Array.isArray(list) && list.length)
  if (!lists.length) return []

  if (expectedCount > 0) {
    const exact = lists.find((list) => list.length === expectedCount)
    if (exact) return exact
    const enough = lists.find((list) => list.length >= expectedCount)
    if (enough) return enough
  }

  return lists.reduce((best, list) => (list.length > best.length ? list : best), lists[0])
}

function normalizeEventRecord(evt, statItem) {
  const eventCode = evt.event || statItem?.event_code
  const typeConfig = findTypeByEventCode(eventCode, statItem?.event_name)
  const rawText = evt.event_text || evt.event_str || ''
  const eventStr =
    rawText && !/^Event\s+\d+$/i.test(rawText)
      ? rawText
      : statItem?.event_name || typeConfig?.label || rawText
  return {
    createtime: evt.createtime || '',
    event_str: eventStr,
    event_name: statItem?.event_name || typeConfig?.label || '',
    event_code: eventCode,
    community_name:
      evt.community_name ||
      evt.area_name ||
      evt.project_name ||
      evt.name ||
      '',
    picture_file: evt.img || evt.picture_file || evt.image || ''
  }
}

function parseTodayEventStatArray(list) {
  const counts = {}
  const todayEvents = []

  list.forEach((item) => {
    if (!item || typeof item !== 'object') return
    const typeConfig = findTypeByEventCode(item.event_code, item.event_name)
    const count = Number(item.count) || 0

    if (typeConfig) {
      counts[typeConfig.countKey] = count
    }

    if (Array.isArray(item.event_data)) {
      item.event_data.forEach((evt) => {
        todayEvents.push(normalizeEventRecord(evt, item))
      })
    }
  })

  return { counts, todayEvents }
}

function objectToEventCounts(source) {
  const hasCountKeys = DAILY_EVENT_TYPES.some((type) => source[type.countKey] !== undefined)
  if (hasCountKeys) {
    return { ...source }
  }

  const nested =
    source.counts ||
    source.event_counts ||
    source.eventCounts ||
    source.stat ||
    source.list ||
    source.items ||
    source.data

  if (Array.isArray(nested)) {
    return parseTodayEventStatArray(nested).counts
  }

  if (nested && typeof nested === 'object') {
    return objectToEventCounts(nested)
  }

  return {}
}

/**
 * 解析 screen_report_three.today_event_stat
 * 标准结构：[{ event_code, event_name, count, event_data: [...] }]
 */
export function parseTodayEventStat(source) {
  if (!source) {
    return { counts: {}, todayEvents: [], yearStats: null }
  }

  if (Array.isArray(source)) {
    const { counts, todayEvents } = parseTodayEventStatArray(source)
    return { counts, todayEvents, yearStats: null }
  }

  if (typeof source !== 'object') {
    return { counts: {}, todayEvents: [], yearStats: null }
  }

  const yearStats = parseYearStatsFromObject(source)
  const counts = objectToEventCounts(source)

  return { counts, todayEvents: [], yearStats }
}

/** 周排查：解析 last_week_event_stat（结构同 today_event_stat） */
export function parseLastWeekEventStat(source) {
  return parseTodayEventStat(source)
}

/** 月调度：解析 last_month_event_stat（结构同 today_event_stat） */
export function parseLastMonthEventStat(source) {
  return parseTodayEventStat(source)
}

/** 月调度：上月板块统计 last_month_total / last_last_month_total / event_total */
export function parseLastMonthEventStats(data = {}) {
  return parsePeriodEventStats(data, {
    primaryKeys: ['last_month_total'],
    secondaryKeys: ['last_last_month_total'],
    totalKeys: ['event_total']
  })
}

/** 月调度：本月板块统计 month_total / last_month_total / event_total */
export function parseThisMonthEventStats(data = {}) {
  return parsePeriodEventStats(data, {
    primaryKeys: ['month_total'],
    secondaryKeys: ['last_month_total'],
    totalKeys: ['event_total']
  })
}

/**
 * 左侧统计：可配置周期字段
 */
export function parsePeriodEventStats(data = {}, options = {}) {
  const {
    primaryKeys = [],
    secondaryKeys = [],
    totalKeys = ['event_total', 'total', 'event_total_num'],
    historyStat = null
  } = options

  const historyList = Array.isArray(historyStat) ? historyStat : []
  const historyTotal = historyList.reduce(
    (sum, item) => sum + (Number(item?.total_count) || 0),
    0
  )

  const pickNumber = (keys, source) => {
    for (const key of keys) {
      const val = Number(source[key])
      if (Number.isFinite(val)) return val
    }
    return Number.NaN
  }

  const primary = pickNumber(primaryKeys, data)
  const secondary = pickNumber(secondaryKeys, data)
  const total = pickNumber(totalKeys, data)

  return {
    thisYear: Number.isFinite(primary) ? primary : 0,
    lastYear: Number.isFinite(secondary) ? secondary : 0,
    total: Number.isFinite(total) ? total : historyTotal
  }
}

/** 日管控：today_total / lastday_total / event_total */
export function parseEventYearStats(historyStat, data = {}) {
  return parsePeriodEventStats(data, {
    primaryKeys: ['today_total'],
    secondaryKeys: [
      'lastday_total',
      'last_day_total',
      'total_last_year',
      'last_year_event_total',
      'last_year',
      'lastYear'
    ],
    historyStat
  })
}

/** 周排查：汇总 event_stat 数组中的 count */
export function sumEventStatCounts(eventStat) {
  if (!Array.isArray(eventStat)) return Number.NaN
  return eventStat.reduce(
    (sum, item) => sum + (Number(item?.count) || 0),
    0
  )
}

/** 周排查：汇总 last_week_stat（旧接口） */
export function sumLastWeekStat(lastWeekStat) {
  if (!Array.isArray(lastWeekStat)) return Number.NaN
  return lastWeekStat.reduce(
    (sum, item) => sum + (Number(item?.last_week_count) || 0),
    0
  )
}

/** 周排查：last_week_stat → countKey 映射 */
export function parseLastWeekStatCounts(lastWeekStat) {
  const counts = {}
  if (!Array.isArray(lastWeekStat)) return counts

  lastWeekStat.forEach((item) => {
    if (!item || typeof item !== 'object') return
    const typeConfig = findTypeByEventCode(item.event_code, item.event_name)
    const count = Number(item.last_week_count) || 0
    if (typeConfig) {
      counts[typeConfig.countKey] = count
    }
  })

  return counts
}

/** 周排查：上周板块统计 last_week_total / last_last_week_total / event_total */
export function parseLastWeekEventStats(data = {}) {
  const stats = parsePeriodEventStats(data, {
    primaryKeys: ['last_week_total', 'lastweek_total'],
    secondaryKeys: [
      'last_last_week_total',
      'last_lastweek_total',
      'before_lastweek_total',
      'lastweek_before_total',
      'before_last_week_total'
    ],
    totalKeys: ['event_total']
  })

  return stats
}

/** 周排查：本周板块统计 week_total / last_week_total / event_total */
export function parseThisWeekEventStats(data = {}) {
  const stats = parsePeriodEventStats(data, {
    primaryKeys: ['week_total', 'thisweek_total', 'this_week_total'],
    secondaryKeys: ['last_week_total', 'lastweek_total'],
    totalKeys: ['event_total']
  })

  const lastWeekSum = sumEventStatCounts(data.last_week_event_stat)
  if (Number.isFinite(lastWeekSum) && stats.lastYear === 0) {
    stats.lastYear = lastWeekSum
  }
  return stats
}

export function buildEventCountsFromEvents(events = []) {
  const counts = {}
  if (!Array.isArray(events)) return counts

  events.forEach((evt) => {
    const typeConfig = findTypeByEventCode(
      evt.event_code || evt.event,
      evt.event_name || evt.event_str
    )
    if (typeConfig) {
      counts[typeConfig.countKey] = (counts[typeConfig.countKey] || 0) + 1
    }
  })

  return counts
}

export function buildEventCountsFromEventByType(eventByType) {
  const counts = {}
  if (!Array.isArray(eventByType)) return counts

  eventByType.forEach((item) => {
    const typeConfig = findTypeByEventCode(item.event ?? item.event_code, item.event_name)
    const count = Number(item.num ?? item.count) || 0
    if (typeConfig && count > 0) {
      counts[typeConfig.countKey] = (counts[typeConfig.countKey] || 0) + count
    }
  })

  return counts
}

function filterFlatEventsByGroup(flatEvents, eventCode, eventName) {
  if (!Array.isArray(flatEvents)) return []

  const code = eventCode != null && eventCode !== '' ? String(eventCode) : ''
  const name = (eventName || '').trim()
  const groupType = findTypeByEventCode(eventCode, eventName)

  return flatEvents.filter((evt) => {
    if (groupType) {
      const evtType = getEventTypeFromRecord(evt)
      if (evtType && evtType.countKey === groupType.countKey) {
        return true
      }
    }

    const evtCode = evt.event_code ?? evt.event
    if (code && evtCode != null && evtCode !== '' && String(evtCode) === code) {
      return true
    }

    const evtName = (evt.event_name || '').trim()
    if (name && evtName && (evtName === name || evtName.includes(name) || name.includes(evtName))) {
      return true
    }

    const evtStr = (evt.event_str || evt.event_text || '').trim()
    if (name && evtStr && (evtStr.includes(name) || name.includes(evtStr))) {
      return true
    }

    if (groupType && evtStr) {
      return groupType.matchKeywords.some((keyword) => evtStr.includes(keyword))
    }

    return false
  })
}

function parseGroupItemEvents(item, flatEvents = []) {
  const eventCode = item.event ?? item.event_code ?? item.group_code
  const eventName =
    item.event_name ||
    item.group_name ||
    item.name ||
    item.type_name ||
    ''

  const fromFlat = filterFlatEventsByGroup(flatEvents, eventCode, eventName)
  const nested = item.event_data || item.events || item.event_list
  const nestedNormalized = Array.isArray(nested) && nested.length
    ? nested.map((evt) => normalizeEventRecord(evt, item))
    : []
  const expectedCount = Number(item.num ?? item.count ?? item.value) || 0

  return pickBetterEventList([fromFlat, nestedNormalized], expectedCount)
}

/** 首页：event_by_type_group → 饼图数据（弹窗事件与分组 count 对齐） */
export function buildHomeEventChartDataFromGroup(eventByTypeGroup, flatEvents = []) {
  if (!Array.isArray(eventByTypeGroup)) return []

  return eventByTypeGroup
    .map((item, index) => {
      if (!item || typeof item !== 'object') return null

      const eventCode = item.event ?? item.event_code ?? item.group_code
      const eventName =
        item.event_name ||
        item.group_name ||
        item.name ||
        item.type_name ||
        ''
      const groupEvents = parseGroupItemEvents(item, flatEvents)
      const countFromApi = Number(item.num ?? item.count ?? item.value)
      const value = Number.isFinite(countFromApi) && countFromApi > 0
        ? countFromApi
        : groupEvents.length

      const typeConfig = findTypeByEventCode(eventCode, eventName)
      const displayName = typeConfig?.shortLabel || eventName || `类型${index + 1}`

      return {
        key: `group-${eventCode ?? eventName ?? index}`,
        label: typeConfig?.label || eventName || displayName,
        shortLabel: displayName,
        eventCode,
        eventName,
        groupEvents,
        value,
        name: displayName,
        itemStyle: {
          color: DAILY_EVENT_CHART_COLORS[index % DAILY_EVENT_CHART_COLORS.length]
        }
      }
    })
    .filter(Boolean)
}

export function filterEventsByChartItem(events, chartItem) {
  if (!chartItem) return []

  const code = chartItem.eventCode ?? chartItem.event_code
  const name = chartItem.eventName ?? chartItem.event_name
  const expectedCount = Number(chartItem.value) || 0
  const fromGroup = Array.isArray(chartItem.groupEvents) ? chartItem.groupEvents : []
  const fromEvents = Array.isArray(events) && events.length
    ? filterFlatEventsByGroup(events, code, name)
    : []

  return pickBetterEventList([fromEvents, fromGroup], expectedCount)
}

export function normalizeHomeEventRecords(list) {
  if (!Array.isArray(list)) return []
  return list.map((item) => {
    const eventCode = item.event ?? item.event_code
    const rawName = item.event_name || ''
    const eventStr = item.event_text || item.event_str || ''
    const typeConfig =
      getEventTypeFromRecord({
        event_code: eventCode,
        event_name: rawName,
        event_str: eventStr,
        event_text: eventStr
      })

    return {
      createtime: item.createtime || '',
      event_str: eventStr,
      event_name: rawName || typeConfig?.label || eventStr || '',
      event_code: eventCode,
      community_name: item.community_name || '',
      picture_file: item.picture_file || item.img || item.image || ''
    }
  })
}

export function buildEventStatsFromCounts(eventCounts = {}) {
  return DAILY_EVENT_TYPES
    .map((item) => ({
      name: item.shortLabel,
      count: getEventCount(eventCounts, item.countKey)
    }))
    .filter((item) => item.count > 0)
}

export function normalizeEventCounts(source) {
  if (!source || typeof source !== 'object') return {}
  return source
}

function parseYearStatsFromObject(source) {
  if (!source || typeof source !== 'object') return null
  const thisYear = Number(source.today_total)
  const lastYear = Number(
    source.lastday_total ??
      source.last_day_total ??
      source.total_last_year ??
      source.last_year_event_total ??
      source.last_year ??
      source.lastYear ??
      source.last_year_total
  )
  const total = Number(source.event_total ?? source.total ?? source.event_total_num)
  const yearStats = {
    thisYear: Number.isFinite(thisYear) ? thisYear : 0,
    lastYear: Number.isFinite(lastYear) ? lastYear : 0,
    total: Number.isFinite(total) ? total : 0
  }
  if (yearStats.thisYear > 0 || yearStats.lastYear > 0 || yearStats.total > 0) {
    return yearStats
  }
  return null
}

export function getEventCount(eventCounts, countKey) {
  const val = eventCounts[countKey]
  const num = Number(val)
  return Number.isFinite(num) ? num : 0
}

export function buildDailyEventSummaryText(eventCounts = {}) {
  return DAILY_EVENT_TYPES
    .map((item) => `${item.label}${getEventCount(eventCounts, item.countKey)}次`)
    .join('，')
}

export function buildDailyEventChartData(eventCounts = {}) {
  return DAILY_EVENT_TYPES.map((item, index) => ({
    key: item.key,
    label: item.label,
    shortLabel: item.shortLabel,
    countKey: item.countKey,
    eventCode: item.eventCode,
    matchKeywords: item.matchKeywords,
    value: getEventCount(eventCounts, item.countKey),
    name: item.shortLabel,
    itemStyle: { color: DAILY_EVENT_CHART_COLORS[index % DAILY_EVENT_CHART_COLORS.length] }
  }))
}

export function matchEventToType(evt, typeConfig) {
  if (!evt || !typeConfig) return false
  const evtCode = Number(evt.event_code || evt.event)
  if (typeConfig.eventCode && evtCode === Number(typeConfig.eventCode)) {
    return true
  }
  const text = `${evt.event_name || ''}${evt.event_str || ''}`
  if (!text) return false
  return typeConfig.matchKeywords.some((keyword) => text.includes(keyword))
}

export function filterEventsByType(events, typeConfig) {
  if (!Array.isArray(events) || !typeConfig) return []
  return events.filter((evt) => matchEventToType(evt, typeConfig))
}

export function sumEventCounts(eventCounts = {}) {
  return DAILY_EVENT_TYPES.reduce(
    (sum, item) => sum + getEventCount(eventCounts, item.countKey),
    0
  )
}
